import * as React from "react";

interface IProps {
	src: string;
	onerror(): any;
}

const CustomProtocolHandler: React.FC<IProps> = (props) => {
	return (
		<iframe
			title="custom protocol handler"
			src={props.src}
			style={{ display: "none" }}
			onError={props.onerror}
		/>
	);
};

export default CustomProtocolHandler;
